var y = (w, g, d) => new Promise((c, u) => {
  var t = (r) => {
    try {
      a(d.next(r));
    } catch (m) {
      u(m);
    }
  }, f = (r) => {
    try {
      a(d.throw(r));
    } catch (m) {
      u(m);
    }
  }, a = (r) => r.done ? c(r.value) : Promise.resolve(r.value).then(t, f);
  a((d = d.apply(w, g)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { postSpecialApplyCreate as S } from "../../request/designordercenter/productionOrder/specialApply/create/post.js";
import { getDict as N } from "@oppein/op-utils";
import { defineComponent as M, useTemplateRef as h, onMounted as P, openBlock as E, createElementBlock as U, createElementVNode as C, createVNode as l, withCtx as s, createTextVNode as D, Fragment as j } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useMessage as q } from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/use-message.js";
import { ref as i, unref as n } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import z from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/spin/src/Spin.js";
import G from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/card/src/Card.js";
import H from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/form/src/Form.js";
import k from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/form/src/FormItem.js";
import { toDisplayString as J } from "../../node_modules/.pnpm/@vue_shared@3.5.18/node_modules/@vue/shared/dist/shared.esm-bundler.js";
import K from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/input/src/Input.js";
import I from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/button/src/Button.js";
import L from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/modal/src/Modal.js";
const Q = { style: { width: "100%", display: "flex", "justify-content": "center" } }, ue = /* @__PURE__ */ M({
  __name: "notAiCancelDialog.ce",
  emits: ["submit"],
  setup(w, { expose: g, emit: d }) {
    const c = h("notAiCancelDialogContainer"), u = q(), t = i(!1), f = h("formRef"), a = i(!1), r = i([]), m = i([]), p = i({
      modifyReason: ""
    }), R = i(""), A = {
      modifyReason: {
        required: !0,
        message: "订单取消操作不可撤销",
        trigger: ["blur", "input"]
      }
    }, O = () => y(this, null, function* () {
      const [o, e] = yield Promise.all([N("ROOT_brand"), N("ROOT_category")]);
      r.value = o, m.value = e;
    }), _ = () => {
      var o;
      p.value = {
        modifyReason: ""
      }, (o = f.value) == null || o.restoreValidation();
    }, T = () => y(this, null, function* () {
      var o;
      try {
        yield (o = f.value) == null ? void 0 : o.validate(), a.value = !0;
        const e = yield S({
          orderId: b.value.orderId,
          specialApplyType: "cancel_bpm_process",
          reason: p.value.modifyReason,
          isAutomatic: 1
        });
        e && e.status ? (u.success("订单取消申请已提交，请等待审批"), t.value = !1, _(), a.value = !1) : (a.value = !1, t.value = !1);
      } catch (e) {
        a.value = !1, e != null && e.errors || (console.error("请求失败:", e), u.error("请完善必填信息"));
      }
    }), b = i({
      orderId: ""
    });
    P(() => y(this, null, function* () {
      yield O();
    }));
    let v = null;
    function V(o) {
      b.value.orderId = o.orderId || "", R.value = o.productionOrderContractNo || "", t.value = !0;
    }
    const B = () => {
      t.value = !1, _(), v = null, b.value = {
        orderId: ""
      };
    }, F = () => {
      t.value = !1, _(), v && (v([]), v = null);
    };
    return g({ open: V }), (o, e) => (E(), U(j, null, [
      C("div", {
        ref_key: "notAiCancelDialogContainer",
        ref: c
      }, null, 512),
      l(n(L), {
        bordered: "",
        show: t.value,
        "onUpdate:show": e[1] || (e[1] = (x) => t.value = x),
        "mask-closable": !1,
        "z-index": 9999,
        to: c.value || "body"
      }, {
        default: s(() => [
          l(n(z), { show: a.value }, {
            default: s(() => [
              l(n(G), {
                style: { width: "655px" },
                title: "取消订单",
                bordered: !1,
                role: "dialog",
                closable: "",
                onClose: B
              }, {
                default: s(() => [
                  l(n(H), {
                    ref_key: "formRef",
                    ref: f,
                    model: p.value,
                    rules: A,
                    "label-placement": "left",
                    "label-width": "130px"
                  }, {
                    default: s(() => [
                      l(n(k), { label: "订单合同自编号：" }, {
                        default: s(() => [
                          C("span", null, J(R.value || ""), 1)
                        ]),
                        _: 1
                      }),
                      l(n(k), {
                        label: "取消原因：",
                        path: "modifyReason"
                      }, {
                        default: s(() => [
                          l(n(K), {
                            type: "textarea",
                            value: p.value.modifyReason,
                            "onUpdate:value": e[0] || (e[0] = (x) => p.value.modifyReason = x),
                            placeholder: "请输入取消原因，最多500字",
                            maxlength: 500,
                            "show-count": "",
                            style: { width: "600px", "min-height": "100px" }
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model"]),
                  C("div", Q, [
                    l(n(I), {
                      onClick: F,
                      style: { "margin-top": "22px", "border-radius": "5px" }
                    }, {
                      default: s(() => e[2] || (e[2] = [
                        D("取消", -1)
                      ])),
                      _: 1,
                      __: [2]
                    }),
                    l(n(I), {
                      onClick: T,
                      style: { "margin-left": "30px", "margin-top": "22px", "background-color": "#3370ff !important", "border-color": "#3370ff !important", "--n-border": "1px solid #3370ff", "--n-button-color": "#fff !important", "border-radius": "5px" },
                      type: "primary"
                    }, {
                      default: s(() => e[3] || (e[3] = [
                        D("确认", -1)
                      ])),
                      _: 1,
                      __: [3]
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["show"])
        ]),
        _: 1
      }, 8, ["show", "to"])
    ], 64));
  }
});
export {
  ue as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/ai-cancel-dialog/notAiCancelDialog.ce.vue.js
// module id = 1152
// module chunks = 41